import { DependencyList, EffectCallback, useEffect } from "react";

import useIsFirstRender from "./useIsFirstRender";

export default function useUpdatedEffect(
  effect: EffectCallback,
  dependencies?: DependencyList
) {
  const isFirst = useIsFirstRender();

  useEffect(() => {
    if (!isFirst) {
      return effect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
}
